import React from 'react'
import { Tab } from 'semantic-ui-react'
import TextAreaAutosize from 'react-textarea-autosize'

import CallToActionButtonsSettings from 'organisms/CallToActionButtonsSettings'

/***
 * @param {string} confirmationMessage
 * @param {function} handleConfirmationMessageChange
 * @param {object} surveyLanguage
 */
export const confirmationMessagePanes = (
  confirmationMessage,
  handleConfirmationMessageChange,
  surveyLanguage
) => [
  {
    menuItem: { key: 'positive', icon: 'smile green', content: 'Positive' },
    render: () => (
      <Tab.Pane>
        <div className="field">
          <label>Content for "Positive" sentiment</label>
          <TextAreaAutosize
            value={confirmationMessage.positive}
            onChange={handleConfirmationMessageChange}
          />
          <CallToActionButtonsSettings ratingType="positive" surveyLanguage={surveyLanguage} />
        </div>
      </Tab.Pane>
    ),
  },
  {
    menuItem: { key: 'neutral', icon: 'meh yellow', content: 'Neutral' },
    render: () => (
      <Tab.Pane>
        <div className="field">
          <label>Content for "Neutral" sentiment</label>
          <TextAreaAutosize
            value={confirmationMessage.neutral}
            onChange={handleConfirmationMessageChange}
          />
          <CallToActionButtonsSettings ratingType="neutral" surveyLanguage={surveyLanguage} />
        </div>
      </Tab.Pane>
    ),
  },
  {
    menuItem: { key: 'negative', icon: 'frown red', content: 'Negative' },
    render: () => (
      <Tab.Pane>
        <div className="field">
          <label>Content for "Negative" sentiment</label>
          <TextAreaAutosize
            value={confirmationMessage.negative}
            onChange={handleConfirmationMessageChange}
          />
          <CallToActionButtonsSettings ratingType="negative" surveyLanguage={surveyLanguage} />
        </div>
      </Tab.Pane>
    ),
  },
]



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Surveys/LandingPageSettings/confirmationMessagePanes.js